export default __webpack_public_path__ + "static/media/clojure.1f0fdef5.svg";